import script from "./WizardSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import HighlightedText from "@/components/neue/wizard/HighlightedText.js";
script.components = Object.assign({}, { HighlightedText }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { HighlightedText }, script.__o.components);}